import { injectFontFallbacks } from './inject-font-fallbacks';
export const applyFontFallbacksString = (fontFamily) => injectFontFallbacks(fontFamily);
//# sourceMappingURL=apply-font-fallbacks-string.js.map